import { render, staticRenderFns } from "./CaptchaText.vue?vue&type=template&id=24c82f7f&"
import script from "./CaptchaText.vue?vue&type=script&lang=js&"
export * from "./CaptchaText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports